import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/angular';

import {
    CompanyService,
    Student,
    StudentHistory,
    StudentService,
    Company,
} from '../../../../_services';
import { ToasterService } from '../../../_shared/toaster/toaster.service';

@Component({
    selector: 'student-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss'],
    providers: [TranslatePipe],
})
export class StudentDetailComponent implements OnInit {
    studentId: string;
    currentStudent: Student;
    studentHistory: StudentHistory;

    constructor(
        private studentService: StudentService,
        private companyService: CompanyService,
        private trans: Transition,
        private toasterService: ToasterService
    ) {}

    ngOnInit(): void {
        this.studentId = this.trans.params()['id'];
        this.fetchStudent(this.studentId);
        this.fetchStudentHistory(this.studentId);
    }

    fetchStudent(id) {
        this.studentService.findById(id).subscribe((student) => {
            this.currentStudent = student;
        });
    }

    fetchStudentHistory(id) {
        this.studentService.historyById(id).subscribe((studentHistory) => {
            this.studentHistory = studentHistory;
        });
    }

    save(): void {
        const student = JSON.parse(JSON.stringify(this.currentStudent));
        this.studentService.update(student).subscribe(
            (response) => {
                if (response !== null) {
                    this.isSuccessful();
                }
            },
            (error) => {
                this.toasterService.error();
            }
        );
    }

    searchCompanies(keyword: string) {
        return this.companyService.search(keyword);
    }

    myListFormatter(data: any): string {
        let html = '';
        html += data.name ? `<span><strong>${data.name}</strong></span>` : '';
        html += data.id ? `<span> (${data.id})</span>` : '';
        html += data.city ? `<span> - ${data.city}</span>` : '';

        return html;
    }

    changeCompany(newVal) {
        if (
            newVal !== null &&
            typeof newVal !== 'undefined' &&
            newVal.id !== null &&
            typeof newVal.id !== 'undefined'
        ) {
            this.currentStudent.companyId = newVal.id;
            this.currentStudent.companyName = newVal.name;
        }
    }

    validate(event) {
        event.preventDefault();
        this.studentService
            .update(this.currentStudent)
            .subscribe((response) => {
                if (response !== null) {
                    this.isSuccessful();
                }
            });
    }

    private isSuccessful() {
        this.toasterService.success();
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/directory/student/detail/detail.component.ts